"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegativePointIcon = exports.PositivePointIcon = void 0;
var tslib_1 = require("tslib");
var AddCircle_1 = tslib_1.__importDefault(require("@material-ui/icons/AddCircle"));
var RemoveCircle_1 = tslib_1.__importDefault(require("@material-ui/icons/RemoveCircle"));
exports.PositivePointIcon = AddCircle_1.default;
exports.NegativePointIcon = RemoveCircle_1.default;
